import { useState } from 'react'

import { CardRadio } from '@/components/ui/CardRadio'
import { Demo, DsSection } from '../primitives'

const CATEGORIES = ['Overall scene', 'Vehicle / equipment damage', 'Roadway conditions']

/**
 * CAI-staff-only design-system reference section for CardRadio — the
 * single-select sibling of CardCheckbox, e.g. the claim-photo category
 * picker (ClaimPhotoUploader).
 */
export function CardRadioSection() {
  const [active, setActive] = useState(CATEGORIES[0])

  return (
    <DsSection
      id="card-radio"
      title="Card radio"
      intro={
        <>
          The <code>&lt;CardRadio&gt;</code> component, used in the claim photo uploader.
        </>
      }
    >
      <Demo label="Single-select — claim photo category">
        <div className="flex flex-col gap-2">
          {CATEGORIES.map((label) => (
            <CardRadio key={label} isSelected={active === label} onSelect={() => setActive(label)}>
              {label}
            </CardRadio>
          ))}
        </div>
      </Demo>
      <Demo label="Green “complete” variant — already has data">
        <div className="flex flex-col gap-2">
          <CardRadio isSelected={false} onSelect={() => undefined} green>
            Overall scene
          </CardRadio>
          <CardRadio isSelected={true} onSelect={() => undefined}>
            Vehicle / equipment damage
          </CardRadio>
        </div>
      </Demo>
      <Demo label="Disabled">
        <CardRadio isSelected={false} onSelect={() => undefined} disabled>
          Roadway conditions
        </CardRadio>
      </Demo>
    </DsSection>
  )
}
